import { useSubscription } from '@apollo/client';
import { gql } from 'graphql-tag';

export const PROJECT_SOW_PARSING_SUBSCRIPTION = gql`
  subscription ProjectSOWParsingCompleted($userUri: String!) {
    projectSOWParsingCompleted(userUri: $userUri) {
      id
      slug
      displayText
    }
  }
`;

const useProjectSOWParsingSubscription = ({ userUri, skipSubscription }) => {
  const { data: { projectSOWParsingCompleted } = {} } = useSubscription(
    PROJECT_SOW_PARSING_SUBSCRIPTION,
    {
      variables: { userUri },
      skip: skipSubscription
    }
  );

  return (
    projectSOWParsingCompleted || {
      slug: null,
      displayText: null
    }
  );
};

export default useProjectSOWParsingSubscription;
